import { render, staticRenderFns } from "./DropdownClassification.vue?vue&type=template&id=fb35c0b6&scoped=true&"
import script from "./DropdownClassification.vue?vue&type=script&lang=ts&"
export * from "./DropdownClassification.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownClassification.vue?vue&type=style&index=0&id=fb35c0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb35c0b6",
  null
  
)

export default component.exports